require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

import 'bootstrap';
import '@popperjs/core';
import "../stylesheets/styles";
import "./enlarge";

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
global.$ = jQuery;
//require("@nathanvda/cocoon")

document.addEventListener("turbolinks:load", () => {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover()
    $('.toast').toast({ autohide: false })
    $('#toast').toast('show')
  })

document.addEventListener("turbolinks:load", function() {
    $('[data-toggle="collapse"]').on("click", function() {
        if($($(this).data('target')).hasClass('collapsing')) return false;
    });
});
document.addEventListener('turbolinks:load', function() {
  console.log('Dir manager loaded!');
    return $('.card.tile.file').on("click", function() {
      console.log('A card is clicked');
      $('#selectedFileDesc').text($(this).find('.file-actions .download').attr('href'));
      $('#selectedFileCreated').text($(this).find('.card-footer .card-title').attr('data-created'));
    });
  });

